export const apiKey = 'cf68c9f5-2900-4a80-a413-8347d137161a';
export const iabVersion = 2;
// export const apiKey = 'd3e8db8b-9fc7-43ab-80e2-20b53653782f';
// const apiSecret = 'RDqcVWwXDrFL7TkxwYrYjZBych3NJQGwrkT6XjQ8nwwWqAamxDgzcjgdHQFf3c24';
